import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { _keys, sortArray } from '@nu-art/ts-common';
import { TS_Tree } from '../TS_Tree/index.js';
import { AdapterBuilder } from '../adapter/Adapter.js';
import { _className } from '../../utils/tools.js';
import { LL_H_C } from '../Layouts/index.js';
import './TS_JSONViewer.scss';
import { TS_Icons } from '@nu-art/ts-styles';
export class TS_JSONViewer extends ComponentSync {
    multiRenderer = {
        root: () => _jsx(_Fragment, {}),
        item: (props) => this.renderTreeItem(props)
    };
    deriveStateFromProps(nextProps, state) {
        state.item = nextProps.item;
        if (nextProps.filterGeneratedFields)
            _keys(state.item).forEach(key => {
                if (key.startsWith('_'))
                    delete state.item[key];
            });
        return state;
    }
    createTree = (parentNode) => {
        //If parentNode wasn't passed, start the parent node as the root
        parentNode ??= { type: 'root', item: this.state.item, };
        //Set the children for this parentNode
        const item = parentNode.type === 'root' ? parentNode.item : parentNode.item.value;
        const keys = _keys(item);
        if (!Array.isArray(item))
            sortArray(keys);
        parentNode._children = keys.map(childKey => {
            const child = item[childKey];
            const node = { type: 'item', item: { key: childKey, value: child } };
            //recursively fill children for object children nodes
            return typeof child === 'object' ? this.createTree(node) : node;
        });
        return parentNode;
    };
    render() {
        const tree = this.createTree();
        const adapter = AdapterBuilder()
            .tree()
            .multiRender(this.multiRenderer)
            .setExpandCollapseRenderer(this.renderTreeExpandIcon)
            .hideRoot()
            .setData(tree)
            .build();
        return _jsx("div", { className: 'ts-json-viewer', children: _jsx(TS_Tree, { adapter: adapter }) });
    }
    renderTreeItem = (props) => {
        const { key, value } = props.item;
        const className = _className('ts-json-viewer__item', typeof value);
        const stringedValue = JSON.stringify(value);
        return _jsxs(LL_H_C, { className: className, children: [_jsxs("div", { className: 'ts-json-viewer__item__key', children: [key, ":"] }), (typeof value !== 'object' || !props.node.expanded) &&
                    _jsx("div", { className: 'ts-json-viewer__item__value', children: stringedValue })] });
    };
    renderTreeExpandIcon = (props) => {
        if (typeof props.item.item.value !== 'object')
            return _jsx("div", { className: 'ts-json-viewer__icon-placeholder' });
        const className = _className('ts-json-viewer__icon', props.node.expanded && 'expanded');
        return _jsx(TS_Icons.treeCollapse.component, { className: className });
    };
}
//# sourceMappingURL=TS_JSONViewer.js.map